import React from 'react';

import {ForgotPasswordForm} from './components';
import Logo from 'components/Logo';
import AnonymousRequired from 'components/AnonymousRequired';

import './styles.css';

class ForgotPassword extends React.Component<any> {
  render() {
    return (
      <div className="ForgotPassword">
        <div className="content">
          <Logo white={true} />
          <ForgotPasswordForm />
        </div>
      </div>
    );
  }
}

export default AnonymousRequired(ForgotPassword);
